
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaca8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaca8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $c98f5a5326e20c95$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.d7a25288.js","6xSCA","tileset.dd00e25b.png","h0uMK","demon.07abaa9f.png","kolwG","hit.a1098d96.mp3","3dBfA","player.429cac3e.png","fAPus","bling.5ae92f5b.mp3","2pqM0","pickup.b7a52900.mp3"]'));

const $82cbb14ddd640a4b$export$5c452ff88e35e47d = new Image();
const $82cbb14ddd640a4b$export$dea52d477af4398a = 8;
const $82cbb14ddd640a4b$export$53b3c91859018cd4 = 128 / $82cbb14ddd640a4b$export$dea52d477af4398a;
const $82cbb14ddd640a4b$export$2dd197b55cf13440 = 128 / $82cbb14ddd640a4b$export$dea52d477af4398a;
var $3d2e95724a29d7a0$exports = {};
$3d2e95724a29d7a0$exports = new URL("tileset.dd00e25b.png", import.meta.url).toString();


const $82cbb14ddd640a4b$var$imageUrl = new URL($3d2e95724a29d7a0$exports);
$82cbb14ddd640a4b$export$5c452ff88e35e47d.src = $82cbb14ddd640a4b$var$imageUrl.toString();


const $b538644da75a1e4a$var$canvas = document.getElementById("canvas");
if (!$b538644da75a1e4a$var$canvas || !($b538644da75a1e4a$var$canvas instanceof HTMLCanvasElement)) throw new Error("Missing canvas");
const $b538644da75a1e4a$export$fae5d17304677194 = 8;
const $b538644da75a1e4a$export$6a6dcc7e725abed4 = 15;
const $b538644da75a1e4a$export$9ecce7f637e2cef2 = 11;
$b538644da75a1e4a$var$canvas.width = Math.floor((0, $82cbb14ddd640a4b$export$dea52d477af4398a) * $b538644da75a1e4a$export$6a6dcc7e725abed4 * $b538644da75a1e4a$export$fae5d17304677194);
$b538644da75a1e4a$var$canvas.height = Math.floor((0, $82cbb14ddd640a4b$export$dea52d477af4398a) * $b538644da75a1e4a$export$9ecce7f637e2cef2 * $b538644da75a1e4a$export$fae5d17304677194);
const $b538644da75a1e4a$var$ctx = $b538644da75a1e4a$var$canvas.getContext("2d");
if (!$b538644da75a1e4a$var$ctx) throw new Error("Missing context");
// @ts-ignore
$b538644da75a1e4a$var$ctx.webkitImageSmoothingEnabled = false;
// @ts-ignore
$b538644da75a1e4a$var$ctx.mozImageSmoothingEnabled = false;
$b538644da75a1e4a$var$ctx.imageSmoothingEnabled = false;
$b538644da75a1e4a$var$ctx.scale($b538644da75a1e4a$export$fae5d17304677194, $b538644da75a1e4a$export$fae5d17304677194);
const $b538644da75a1e4a$export$671da467341b3aba = ()=>({
        canvas: $b538644da75a1e4a$var$canvas,
        ctx: $b538644da75a1e4a$var$ctx
    });
const $b538644da75a1e4a$export$a1c066623ac679d3 = ()=>{
    $b538644da75a1e4a$var$ctx.clearRect(0, 0, $b538644da75a1e4a$var$canvas.width, $b538644da75a1e4a$var$canvas.height);
    $b538644da75a1e4a$var$ctx.moveTo(0, 0);
    $b538644da75a1e4a$var$ctx.fillStyle = "#191B1A";
    $b538644da75a1e4a$var$ctx.beginPath();
    $b538644da75a1e4a$var$ctx.rect(0, 0, $b538644da75a1e4a$var$canvas.width, $b538644da75a1e4a$var$canvas.height);
    $b538644da75a1e4a$var$ctx.fill();
};



const { ctx: $56639639c2c4b13a$var$ctx } = (0, $b538644da75a1e4a$export$671da467341b3aba)();
const $56639639c2c4b13a$export$5c452ff88e35e47d = new Image();
const $56639639c2c4b13a$export$dea52d477af4398a = 24;
const $56639639c2c4b13a$var$frames = 5;
var $f95ebd5b198100ce$exports = {};
$f95ebd5b198100ce$exports = new URL("demon.07abaa9f.png", import.meta.url).toString();


const $56639639c2c4b13a$var$imageUrl = new URL($f95ebd5b198100ce$exports);
$56639639c2c4b13a$export$5c452ff88e35e47d.src = $56639639c2c4b13a$var$imageUrl.toString();
const $56639639c2c4b13a$var$frameLength = 20;
let $56639639c2c4b13a$var$acc = 0;
let $56639639c2c4b13a$var$frame = 0;
const $56639639c2c4b13a$export$853d2a5c417256da = (demon)=>{
    if (!demon.isActive) return;
    $56639639c2c4b13a$var$acc++;
    if ($56639639c2c4b13a$var$acc >= $56639639c2c4b13a$var$frameLength) {
        $56639639c2c4b13a$var$frame++;
        $56639639c2c4b13a$var$acc = 0;
    }
    if ($56639639c2c4b13a$var$frame >= $56639639c2c4b13a$var$frames) $56639639c2c4b13a$var$frame = 0;
    const column = Math.floor($56639639c2c4b13a$var$frame % $56639639c2c4b13a$var$frames);
    const row = Math.floor($56639639c2c4b13a$var$frame / $56639639c2c4b13a$var$frames);
    const xOffset = Math.floor(column * $56639639c2c4b13a$export$dea52d477af4398a);
    const yOffset = Math.round(row * $56639639c2c4b13a$export$dea52d477af4398a);
    const x = demon.x - demon.w * 0.5;
    const y = demon.y - demon.h * 0.5;
    $56639639c2c4b13a$var$ctx.drawImage($56639639c2c4b13a$export$5c452ff88e35e47d, xOffset, yOffset, $56639639c2c4b13a$export$dea52d477af4398a, $56639639c2c4b13a$export$dea52d477af4398a, x, y, demon.w, demon.h);
    $56639639c2c4b13a$var$drawHealthBar(demon);
    if (demon.debug) {
        $56639639c2c4b13a$var$ctx.strokeStyle = "#FFFFFF";
        $56639639c2c4b13a$var$ctx.lineWidth = 1 / 8;
        $56639639c2c4b13a$var$ctx.beginPath();
        $56639639c2c4b13a$var$ctx.rect(x, y, demon.w, demon.h);
        $56639639c2c4b13a$var$ctx.stroke();
        $56639639c2c4b13a$var$ctx.beginPath();
        $56639639c2c4b13a$var$ctx.moveTo(x, y);
        $56639639c2c4b13a$var$ctx.lineTo(x + demon.w, y + demon.h);
        $56639639c2c4b13a$var$ctx.stroke();
        $56639639c2c4b13a$var$ctx.beginPath();
        $56639639c2c4b13a$var$ctx.moveTo(x + demon.w, y);
        $56639639c2c4b13a$var$ctx.lineTo(x, y + demon.h);
        $56639639c2c4b13a$var$ctx.stroke();
    }
};
const $56639639c2c4b13a$var$drawHealthBar = (demon)=>{
    const x = 1;
    const y = 1;
    const w = 50;
    const h = 5;
    const margin = 0.5;
    // Health bar
    $56639639c2c4b13a$var$ctx.beginPath();
    $56639639c2c4b13a$var$ctx.fillStyle = "#191b1a";
    $56639639c2c4b13a$var$ctx.rect(x, y, w, h);
    $56639639c2c4b13a$var$ctx.fill();
    $56639639c2c4b13a$var$ctx.beginPath();
    $56639639c2c4b13a$var$ctx.fillStyle = "#294257";
    $56639639c2c4b13a$var$ctx.rect(x + margin, y + margin, w - margin * 2, h - margin * 2);
    $56639639c2c4b13a$var$ctx.fill();
    $56639639c2c4b13a$var$ctx.beginPath();
    $56639639c2c4b13a$var$ctx.fillStyle = "#99c9b3";
    $56639639c2c4b13a$var$ctx.rect(x + margin, y + margin, (w - margin * 2) * demon.health, h - margin * 2);
    $56639639c2c4b13a$var$ctx.fill();
};



const $472cf4e5fdf70e6f$var$DEMON_MAX_VEL = 15;
const $472cf4e5fdf70e6f$export$848a8485c85036a9 = (demon, dt)=>{
    if (!demon.isActive) return;
    demon.vel.x = demon.x < (0, $fda0042d7ace4273$export$615455393ee443ca).x ? $472cf4e5fdf70e6f$var$DEMON_MAX_VEL : -$472cf4e5fdf70e6f$var$DEMON_MAX_VEL;
    demon.vel.y = demon.y < (0, $fda0042d7ace4273$export$615455393ee443ca).y ? $472cf4e5fdf70e6f$var$DEMON_MAX_VEL : -$472cf4e5fdf70e6f$var$DEMON_MAX_VEL;
    demon.x += demon.vel.x * dt;
    demon.y += demon.vel.y * dt;
};


var $4e7191e2caed83b6$exports = {};
$4e7191e2caed83b6$exports = new URL("hit.a1098d96.mp3", import.meta.url).toString();


const $f2635be855952ad7$var$hitURL = new URL($4e7191e2caed83b6$exports);
const $f2635be855952ad7$var$hit = new Audio($f2635be855952ad7$var$hitURL.toString());
$f2635be855952ad7$var$hit.load();
const $f2635be855952ad7$export$f1fd645118ed8be8 = {
    x: 70,
    y: 40,
    vel: {
        x: 0,
        y: 0
    },
    w: 24,
    h: 24,
    health: 1,
    debug: false,
    isActive: false,
    update: (dt)=>(0, $472cf4e5fdf70e6f$export$848a8485c85036a9)($f2635be855952ad7$export$f1fd645118ed8be8, dt),
    draw: ()=>(0, $56639639c2c4b13a$export$853d2a5c417256da)($f2635be855952ad7$export$f1fd645118ed8be8),
    hit: ()=>{
        $f2635be855952ad7$export$f1fd645118ed8be8.health -= 0.01;
        $f2635be855952ad7$var$hit.play();
        if ($f2635be855952ad7$export$f1fd645118ed8be8.health <= 0) {
            alert("Game over!");
            $f2635be855952ad7$export$f1fd645118ed8be8.health = 1;
            $f2635be855952ad7$export$f1fd645118ed8be8.isActive = false;
        }
    }
};



const { ctx: $497b2d40f0cf2220$var$ctx } = (0, $b538644da75a1e4a$export$671da467341b3aba)();
const $497b2d40f0cf2220$export$5c452ff88e35e47d = new Image();
const $497b2d40f0cf2220$export$dea52d477af4398a = 8;
const $497b2d40f0cf2220$var$columns = 64 / $497b2d40f0cf2220$export$dea52d477af4398a;
var $d3449b3d5720187b$exports = {};
$d3449b3d5720187b$exports = new URL("player.429cac3e.png", import.meta.url).toString();


const $497b2d40f0cf2220$var$imageUrl = new URL($d3449b3d5720187b$exports);
$497b2d40f0cf2220$export$5c452ff88e35e47d.src = $497b2d40f0cf2220$var$imageUrl.toString();
const $497b2d40f0cf2220$var$frameLength = 30;
let $497b2d40f0cf2220$var$acc = 0;
let $497b2d40f0cf2220$var$frameIndex = 0;
const $497b2d40f0cf2220$export$941190eab9b1306e = (player, dt)=>{
    $497b2d40f0cf2220$var$acc++;
    if ($497b2d40f0cf2220$var$acc >= $497b2d40f0cf2220$var$frameLength) {
        $497b2d40f0cf2220$var$frameIndex++;
        $497b2d40f0cf2220$var$acc = 0;
    }
    if ($497b2d40f0cf2220$var$frameIndex > 2) $497b2d40f0cf2220$var$frameIndex = 0;
    const column = Math.floor($497b2d40f0cf2220$var$frameIndex % $497b2d40f0cf2220$var$columns);
    const row = Math.floor($497b2d40f0cf2220$var$frameIndex / $497b2d40f0cf2220$var$columns);
    const xOffset = Math.floor(column * $497b2d40f0cf2220$export$dea52d477af4398a);
    const yOffset = Math.floor(row * $497b2d40f0cf2220$export$dea52d477af4398a);
    const x = player.x - player.w * 0.5;
    const y = player.y - player.h * 0.5;
    $497b2d40f0cf2220$var$ctx.drawImage($497b2d40f0cf2220$export$5c452ff88e35e47d, xOffset, yOffset, $497b2d40f0cf2220$export$dea52d477af4398a, $497b2d40f0cf2220$export$dea52d477af4398a, x, y, $497b2d40f0cf2220$export$dea52d477af4398a, $497b2d40f0cf2220$export$dea52d477af4398a);
    if (player.debug) {
        $497b2d40f0cf2220$var$ctx.strokeStyle = "#E00000";
        $497b2d40f0cf2220$var$ctx.lineWidth = 0.25;
        $497b2d40f0cf2220$var$ctx.fillStyle = "#FFFFFF";
        $497b2d40f0cf2220$var$ctx.beginPath();
        $497b2d40f0cf2220$var$ctx.rect(x, y, player.w, player.h);
        $497b2d40f0cf2220$var$ctx.stroke();
    }
};
const $497b2d40f0cf2220$export$c0fc52b0bcb1936a = (projectile, dt)=>{
    if (!projectile.isActive) return;
    $497b2d40f0cf2220$var$ctx.fillStyle = "#99c9b3";
    $497b2d40f0cf2220$var$ctx.beginPath();
    $497b2d40f0cf2220$var$ctx.arc(projectile.x, projectile.y, projectile.r, 0, 2 * Math.PI);
    $497b2d40f0cf2220$var$ctx.fill();
};




var $ddf07b7a7e40b7af$export$24193575da0c3ef5;
(function(ROOM_TYPE) {
    ROOM_TYPE[ROOM_TYPE["EMPTY"] = 0] = "EMPTY";
    ROOM_TYPE[ROOM_TYPE["MAIN"] = 1] = "MAIN";
    ROOM_TYPE[ROOM_TYPE["CANDLE_ROOM_1"] = 2] = "CANDLE_ROOM_1";
    ROOM_TYPE[ROOM_TYPE["CANDLE_ROOM_2"] = 3] = "CANDLE_ROOM_2";
    ROOM_TYPE[ROOM_TYPE["CANDLE_ROOM_3"] = 4] = "CANDLE_ROOM_3";
    ROOM_TYPE[ROOM_TYPE["CANDLE_ROOM_4"] = 5] = "CANDLE_ROOM_4";
    ROOM_TYPE[ROOM_TYPE["CANDLE_ROOM_5"] = 6] = "CANDLE_ROOM_5";
})($ddf07b7a7e40b7af$export$24193575da0c3ef5 || ($ddf07b7a7e40b7af$export$24193575da0c3ef5 = {}));



const $93a8f9923f89eb07$var$layout = [
    "Q#############E",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000012300000R",
    "L0000045600000R",
    "L0000078900000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "TBBBBBBBBBBBBBY"
];
const $93a8f9923f89eb07$export$f22da7240b7add18 = $93a8f9923f89eb07$var$layout.join("\n");


const $a6554fe5ae9b6ad3$var$layout = [
    "Q#############E",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "L0000000000000R",
    "TBBBBBBBBBBBBBY"
];
const $a6554fe5ae9b6ad3$export$6e22c362a0406a2c = $a6554fe5ae9b6ad3$var$layout.join("\n");


const $5807aec6125fc5b3$export$1ecca0613f5e56d2 = new Map([
    [
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).MAIN,
        (0, $93a8f9923f89eb07$export$f22da7240b7add18)
    ],
    [
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY,
        (0, $a6554fe5ae9b6ad3$export$6e22c362a0406a2c)
    ]
]);




const { ctx: $3eb093eb1af09297$var$ctx } = (0, $b538644da75a1e4a$export$671da467341b3aba)();
const $3eb093eb1af09297$export$5ed0c7ace38c6286 = (tile)=>{
    const index = tile.type.graphicIndexes[tile.type.currentFrame];
    const column = Math.floor(index % (0, $82cbb14ddd640a4b$export$53b3c91859018cd4));
    const row = Math.floor(index / (0, $82cbb14ddd640a4b$export$53b3c91859018cd4));
    const xOffset = column * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    const yOffset = row * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    const x = tile.x * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    const y = tile.y * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    $3eb093eb1af09297$var$ctx.drawImage((0, $82cbb14ddd640a4b$export$5c452ff88e35e47d), xOffset, yOffset, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a), x, y, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a));
    if (tile.debug) {
        $3eb093eb1af09297$var$ctx.strokeStyle = "#FFFFFF";
        $3eb093eb1af09297$var$ctx.lineWidth = 1 / 8;
        $3eb093eb1af09297$var$ctx.beginPath();
        $3eb093eb1af09297$var$ctx.rect(x, y, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a));
        $3eb093eb1af09297$var$ctx.stroke();
    }
};


const $7ddd36fe8f2e1a51$export$7609c20295700ccc = (tiles)=>{
    tiles.forEach((0, $3eb093eb1af09297$export$5ed0c7ace38c6286));
};




const $c522274b58f2dbd7$var$baseTile = {
    isSolid: false,
    isAnimated: false,
    isInteractive: false,
    acc: 0,
    currentFrame: 0,
    frameDuration: 0,
    graphicIndexes: [
        0
    ]
};
const $c522274b58f2dbd7$export$723aa6ff9f95b23e = new Map();
const $c522274b58f2dbd7$export$5a156de1a5d2f922 = {
    air: {
        ...$c522274b58f2dbd7$var$baseTile
    },
    ground: {
        ...$c522274b58f2dbd7$var$baseTile,
        graphicIndexes: [
            (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 2 + 2
        ]
    },
    wall: {
        topLeft: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                1
            ]
        },
        top: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                2
            ]
        },
        topRight: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                5
            ]
        },
        left: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 1 + 1
            ]
        },
        right: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 1 + 5
            ]
        },
        bottomLeft: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 4 + 1
            ]
        },
        bottom: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 4 + 2
            ]
        },
        bottomRight: {
            ...$c522274b58f2dbd7$var$baseTile,
            isSolid: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 4 + 5
            ]
        }
    },
    gateway: {
        north: {
            ...$c522274b58f2dbd7$var$baseTile,
            isInteractive: true,
            graphicIndexes: [
                3
            ]
        },
        east: {
            ...$c522274b58f2dbd7$var$baseTile,
            isInteractive: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 2 + 5
            ]
        },
        south: {
            ...$c522274b58f2dbd7$var$baseTile,
            isInteractive: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 4 + 3
            ]
        },
        west: {
            ...$c522274b58f2dbd7$var$baseTile,
            isInteractive: true,
            graphicIndexes: [
                (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 2 + 1
            ]
        }
    },
    candle: {
        ...$c522274b58f2dbd7$var$baseTile,
        isAnimated: true,
        isInteractive: true,
        acc: 0,
        currentFrame: 0,
        frameDuration: 30,
        graphicIndexes: [
            9,
            10,
            11,
            12
        ]
    }
};
// General
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set(" ", $c522274b58f2dbd7$export$5a156de1a5d2f922.air);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("0", $c522274b58f2dbd7$export$5a156de1a5d2f922.ground);
// Walls
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("Q", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.topLeft);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("#", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.top);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("E", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.topRight);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("R", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.right);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("L", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.left);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("T", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.bottomLeft);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("B", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.bottom);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("Y", $c522274b58f2dbd7$export$5a156de1a5d2f922.wall.bottomRight);
// Gateways
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("H", $c522274b58f2dbd7$export$5a156de1a5d2f922.gateway.north);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("J", $c522274b58f2dbd7$export$5a156de1a5d2f922.gateway.east);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("N", $c522274b58f2dbd7$export$5a156de1a5d2f922.gateway.south);
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("M", $c522274b58f2dbd7$export$5a156de1a5d2f922.gateway.west);
// Candle
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("C", $c522274b58f2dbd7$export$5a156de1a5d2f922.candle);
// Alter tiles
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("1", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 5
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("2", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 5 + 1
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("3", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 5 + 2
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("4", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 6
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("5", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 6 + 1
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("6", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 6 + 2
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("7", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 7
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("8", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 7 + 1
    ]
});
$c522274b58f2dbd7$export$723aa6ff9f95b23e.set("9", {
    ...$c522274b58f2dbd7$var$baseTile,
    graphicIndexes: [
        (0, $82cbb14ddd640a4b$export$53b3c91859018cd4) * 7 + 2
    ]
});


var $098e597b73ffd03e$export$9f0347034b4ca000;
(function(GATEWAY_DIRECTION) {
    GATEWAY_DIRECTION[GATEWAY_DIRECTION["NORTH"] = 0] = "NORTH";
    GATEWAY_DIRECTION[GATEWAY_DIRECTION["EAST"] = 1] = "EAST";
    GATEWAY_DIRECTION[GATEWAY_DIRECTION["SOUTH"] = 2] = "SOUTH";
    GATEWAY_DIRECTION[GATEWAY_DIRECTION["WEST"] = 3] = "WEST";
})($098e597b73ffd03e$export$9f0347034b4ca000 || ($098e597b73ffd03e$export$9f0347034b4ca000 = {}));
const $098e597b73ffd03e$export$bffedaedfad11873 = (input, gateways)=>{
    const arr = input.split("\n").map((line)=>line.split(""));
    const tiles = [];
    for(let y = 0; y < arr.length; y++){
        const row = arr[y];
        for(let x = 0; x < row.length; x++){
            const char = row[x];
            const tile = {
                x: x,
                y: y,
                debug: false,
                type: (0, $c522274b58f2dbd7$export$723aa6ff9f95b23e).get(char) || (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).air
            };
            tiles.push(tile);
        }
    }
    gateways.forEach((gateway)=>{
        const tile = tiles.find((tile)=>tile.x === gateway.x && tile.y === gateway.y);
        if (!tile) return;
        tile.debug = true;
        tile.gateway = gateway.id;
        switch(gateway.dir){
            case 0:
                tile.target = {
                    x: tile.x,
                    y: (0, $b538644da75a1e4a$export$9ecce7f637e2cef2) - 2
                };
                tile.type = (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).gateway.north;
                break;
            case 1:
                tile.target = {
                    x: 1,
                    y: tile.y
                };
                tile.type = (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).gateway.east;
                break;
            case 2:
                tile.target = {
                    x: tile.x,
                    y: 1
                };
                tile.type = (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).gateway.south;
                break;
            case 3:
                tile.target = {
                    x: (0, $b538644da75a1e4a$export$6a6dcc7e725abed4) - 2,
                    y: tile.y
                };
                tile.type = (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).gateway.west;
                break;
        }
    });
    return tiles;
};


// TODO: randomly generate map layout at some point...
// # = Empty room (with horrors you can't imagine... maybe)
// A = Altar
// 1 = Candle 1
// 2 = Candle 2
// 3 = Candle 3
// 4 = Candle 4
// 5 = Candle 5
const $8ea1e13aabce4ae5$var$roomTypeMap = new Map([
    [
        "#",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ],
    [
        "A",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).MAIN
    ],
    [
        "1",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ],
    [
        "2",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ],
    [
        "3",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ],
    [
        "4",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ],
    [
        "5",
        (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY
    ]
]);
const $8ea1e13aabce4ae5$export$b3219800bda33a1f = [
    [
        "1",
        " ",
        " ",
        " ",
        " ",
        " ",
        "4",
        " "
    ],
    [
        "#",
        "#",
        "#",
        "#",
        "#",
        "#",
        "#",
        "#"
    ],
    [
        " ",
        "#",
        " ",
        "#",
        " ",
        " ",
        " ",
        " "
    ],
    [
        " ",
        "#",
        "#",
        "A",
        "#",
        "#",
        "#",
        " "
    ],
    [
        " ",
        "#",
        " ",
        "#",
        " ",
        " ",
        "#",
        "3"
    ],
    [
        " ",
        "#",
        "#",
        "#",
        " ",
        "#",
        "#",
        " "
    ],
    [
        "2",
        "#",
        " ",
        "#",
        "5",
        " ",
        " ",
        " "
    ]
];
const $8ea1e13aabce4ae5$var$rows = $8ea1e13aabce4ae5$export$b3219800bda33a1f.length;
const $8ea1e13aabce4ae5$var$columns = $8ea1e13aabce4ae5$export$b3219800bda33a1f[0].length;
const $8ea1e13aabce4ae5$var$mapItems = new Map();
for(let y = 0; y < $8ea1e13aabce4ae5$export$b3219800bda33a1f.length; y++){
    const row = $8ea1e13aabce4ae5$export$b3219800bda33a1f[y];
    for(let x = 0; x < row.length; x++){
        const char = row[x];
        if (!char || char === " ") continue;
        const id = `room-${x}-${y}`;
        const type = $8ea1e13aabce4ae5$var$roomTypeMap.get(char) || (0, $ddf07b7a7e40b7af$export$24193575da0c3ef5).EMPTY;
        $8ea1e13aabce4ae5$var$mapItems.set(id, {
            x: x,
            y: y,
            id: id,
            type: type
        });
    }
}
const $8ea1e13aabce4ae5$export$871de8747c9eaa88 = new Map();
$8ea1e13aabce4ae5$var$mapItems.forEach((item)=>{
    const adjacentRooms = [
        {
            x: item.x,
            y: item.y - 1,
            dir: (0, $098e597b73ffd03e$export$9f0347034b4ca000).NORTH
        },
        {
            x: item.x + 1,
            y: item.y,
            dir: (0, $098e597b73ffd03e$export$9f0347034b4ca000).EAST
        },
        {
            x: item.x,
            y: item.y + 1,
            dir: (0, $098e597b73ffd03e$export$9f0347034b4ca000).SOUTH
        },
        {
            x: item.x - 1,
            y: item.y,
            dir: (0, $098e597b73ffd03e$export$9f0347034b4ca000).WEST
        }
    ];
    const gateways = adjacentRooms.reduce((gateways, roomCoords)=>{
        const id = $8ea1e13aabce4ae5$var$mapItems.get(`room-${roomCoords.x}-${roomCoords.y}`)?.id;
        let x = 0;
        let y = 0;
        switch(roomCoords.dir){
            case (0, $098e597b73ffd03e$export$9f0347034b4ca000).NORTH:
                x = Math.floor((0, $b538644da75a1e4a$export$6a6dcc7e725abed4) / 2);
                break;
            case (0, $098e597b73ffd03e$export$9f0347034b4ca000).EAST:
                x = (0, $b538644da75a1e4a$export$6a6dcc7e725abed4) - 1;
                y = Math.floor((0, $b538644da75a1e4a$export$9ecce7f637e2cef2) / 2);
                break;
            case (0, $098e597b73ffd03e$export$9f0347034b4ca000).SOUTH:
                x = Math.floor((0, $b538644da75a1e4a$export$6a6dcc7e725abed4) / 2);
                y = (0, $b538644da75a1e4a$export$9ecce7f637e2cef2) - 1;
                break;
            case (0, $098e597b73ffd03e$export$9f0347034b4ca000).WEST:
                y = Math.floor((0, $b538644da75a1e4a$export$9ecce7f637e2cef2) / 2);
                break;
        }
        return id ? [
            ...gateways,
            {
                x: x,
                y: y,
                id: id,
                dir: roomCoords.dir
            }
        ] : gateways;
    }, []);
    const layout = (0, $5807aec6125fc5b3$export$1ecca0613f5e56d2).get(item.type);
    if (!layout) return;
    const room = {
        id: item.id,
        tiles: (0, $098e597b73ffd03e$export$bffedaedfad11873)(layout, gateways),
        draw: ()=>(0, $7ddd36fe8f2e1a51$export$7609c20295700ccc)(room.tiles)
    };
    $8ea1e13aabce4ae5$export$871de8747c9eaa88.set(item.id, {
        ...item,
        room: room
    });
});
const $8ea1e13aabce4ae5$var$initialRoom = $8ea1e13aabce4ae5$export$871de8747c9eaa88.get("room-3-3")?.room;
const $8ea1e13aabce4ae5$export$f9d3fff8c23da278 = {
    current: $8ea1e13aabce4ae5$var$initialRoom
};



const $29061d6eec20e354$export$116e5f7d3f4c5392 = (player, dt)=>{
    const doorTile = (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.tiles.find((tile)=>!!tile.gateway && tile.x === player.tile.x && tile.y === player.tile.y);
    if (doorTile?.gateway) {
        (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current = (0, $8ea1e13aabce4ae5$export$871de8747c9eaa88).get(doorTile.gateway)?.room;
        player.x = (doorTile.target?.x || 0) * (0, $497b2d40f0cf2220$export$dea52d477af4398a);
        player.y = (doorTile.target?.y || 0) * (0, $497b2d40f0cf2220$export$dea52d477af4398a);
    }
    let nx = player.x + player.vel.x * dt;
    let ny = player.y + player.vel.y * dt;
    const solidTiles = (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.tiles.filter((tile)=>tile.type.isSolid) || [];
    for (const tile of solidTiles){
        const x = tile.x * (0, $497b2d40f0cf2220$export$dea52d477af4398a);
        const y = tile.y * (0, $497b2d40f0cf2220$export$dea52d477af4398a);
        if (nx > x && nx < x + (0, $497b2d40f0cf2220$export$dea52d477af4398a) && ny > y && ny < y + (0, $497b2d40f0cf2220$export$dea52d477af4398a)) {
            nx = player.x;
            ny = player.y;
        }
    }
    player.x = nx;
    player.y = ny;
    // Get player tile
    player.tile.x = Math.floor(player.x / (0, $497b2d40f0cf2220$export$dea52d477af4398a));
    player.tile.y = Math.floor(player.y / (0, $497b2d40f0cf2220$export$dea52d477af4398a));
    if (player.candle) {
        player.candle.x = player.x;
        player.candle.y = player.y;
        player.candle.room = (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.id;
    }
};
const $29061d6eec20e354$export$65b23b1dfb99f88a = (projectile, dt)=>{
    projectile.x += projectile.vel.x * dt;
    projectile.y += projectile.vel.y * dt;
    const dvx = (0, $f2635be855952ad7$export$f1fd645118ed8be8).x - projectile.x;
    const dvy = (0, $f2635be855952ad7$export$f1fd645118ed8be8).y - projectile.y;
    const magnitude = Math.sqrt(dvx * dvx + dvy * dvy);
    if (projectile.isActive && magnitude < (0, $f2635be855952ad7$export$f1fd645118ed8be8).w / 2) {
        (0, $f2635be855952ad7$export$f1fd645118ed8be8).hit();
        projectile.isActive = false;
    }
};


const $fda0042d7ace4273$export$5f4276d44c62d457 = 50;
const $fda0042d7ace4273$export$615455393ee443ca = {
    x: 20,
    y: 30,
    w: 8,
    h: 8,
    vel: {
        x: 0,
        y: 0
    },
    tile: {
        x: 0,
        y: 0
    },
    debug: false,
    update: (dt)=>{
        (0, $29061d6eec20e354$export$116e5f7d3f4c5392)($fda0042d7ace4273$export$615455393ee443ca, dt);
        (0, $29061d6eec20e354$export$65b23b1dfb99f88a)($fda0042d7ace4273$export$c25853900383112d, dt);
    },
    draw: (dt)=>{
        (0, $497b2d40f0cf2220$export$941190eab9b1306e)($fda0042d7ace4273$export$615455393ee443ca, dt);
        (0, $497b2d40f0cf2220$export$c0fc52b0bcb1936a)($fda0042d7ace4273$export$c25853900383112d, dt);
    },
    fire: ()=>$fda0042d7ace4273$var$fireProjectile()
};
const $fda0042d7ace4273$export$c25853900383112d = {
    r: 1,
    x: $fda0042d7ace4273$export$615455393ee443ca.x,
    y: $fda0042d7ace4273$export$615455393ee443ca.y,
    vel: {
        x: 0,
        y: 0
    },
    isActive: false
};
var $1e7d786d10c0e939$exports = {};
$1e7d786d10c0e939$exports = new URL("bling.5ae92f5b.mp3", import.meta.url).toString();


const $fda0042d7ace4273$var$mp3URL = new URL($1e7d786d10c0e939$exports);
const $fda0042d7ace4273$var$bling = new Audio($fda0042d7ace4273$var$mp3URL.toString());
$fda0042d7ace4273$var$bling.load();
const $fda0042d7ace4273$export$f46220a60a54f689 = 100;
const $fda0042d7ace4273$var$fireProjectile = ()=>{
    if ($fda0042d7ace4273$export$c25853900383112d.isActive || !(0, $f2635be855952ad7$export$f1fd645118ed8be8).isActive) return;
    $fda0042d7ace4273$var$bling.pause();
    $fda0042d7ace4273$var$bling.load();
    $fda0042d7ace4273$var$bling.play();
    $fda0042d7ace4273$export$c25853900383112d.x = $fda0042d7ace4273$export$615455393ee443ca.x;
    $fda0042d7ace4273$export$c25853900383112d.y = $fda0042d7ace4273$export$615455393ee443ca.y;
    // Directional vector
    const dvx = (0, $f2635be855952ad7$export$f1fd645118ed8be8).x - $fda0042d7ace4273$export$615455393ee443ca.x;
    const dvy = (0, $f2635be855952ad7$export$f1fd645118ed8be8).y - $fda0042d7ace4273$export$615455393ee443ca.y;
    const magnitude = Math.sqrt(dvx * dvx + dvy * dvy);
    // unit vector
    const uvx = dvx / magnitude;
    const uvy = dvy / magnitude;
    $fda0042d7ace4273$export$c25853900383112d.vel.x = uvx * $fda0042d7ace4273$export$f46220a60a54f689;
    $fda0042d7ace4273$export$c25853900383112d.vel.y = uvy * $fda0042d7ace4273$export$f46220a60a54f689;
    $fda0042d7ace4273$export$c25853900383112d.isActive = true;
};








const { ctx: $f8dab26eb8b17592$var$ctx } = (0, $b538644da75a1e4a$export$671da467341b3aba)();
const $f8dab26eb8b17592$var$tileType = (0, $c522274b58f2dbd7$export$5a156de1a5d2f922).candle;
const $f8dab26eb8b17592$export$c1384d250b581fb0 = (candle)=>{
    const index = $f8dab26eb8b17592$var$tileType.graphicIndexes[$f8dab26eb8b17592$var$tileType.currentFrame];
    const column = Math.floor(index % (0, $82cbb14ddd640a4b$export$53b3c91859018cd4));
    const row = Math.floor(index / (0, $82cbb14ddd640a4b$export$53b3c91859018cd4));
    const xOffset = column * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    const yOffset = row * (0, $82cbb14ddd640a4b$export$dea52d477af4398a);
    const x = candle.x - (0, $82cbb14ddd640a4b$export$dea52d477af4398a) * 0.5;
    const y = candle.y - (0, $82cbb14ddd640a4b$export$dea52d477af4398a) * 0.5;
    $f8dab26eb8b17592$var$ctx.drawImage((0, $82cbb14ddd640a4b$export$5c452ff88e35e47d), xOffset, yOffset, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a), x, y, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a));
    if (candle.debug) {
        $f8dab26eb8b17592$var$ctx.strokeStyle = "#FFFFFF";
        $f8dab26eb8b17592$var$ctx.lineWidth = 1 / 8;
        $f8dab26eb8b17592$var$ctx.beginPath();
        $f8dab26eb8b17592$var$ctx.rect(x, y, (0, $82cbb14ddd640a4b$export$dea52d477af4398a), (0, $82cbb14ddd640a4b$export$dea52d477af4398a));
        $f8dab26eb8b17592$var$ctx.stroke();
    }
};


const $bbf478b8138cf072$export$2d8bb87b05f43b44 = (candle)=>{};


const $4a3bf1a68fc18b3d$var$candle1 = {
    x: 2 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    y: 1 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    debug: false,
    room: "room-0-0",
    update: ()=>(0, $bbf478b8138cf072$export$2d8bb87b05f43b44)($4a3bf1a68fc18b3d$var$candle1),
    draw: ()=>(0, $f8dab26eb8b17592$export$c1384d250b581fb0)($4a3bf1a68fc18b3d$var$candle1)
};
const $4a3bf1a68fc18b3d$var$candle2 = {
    x: 8 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    y: 8 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    debug: false,
    room: "room-0-6",
    update: ()=>(0, $bbf478b8138cf072$export$2d8bb87b05f43b44)($4a3bf1a68fc18b3d$var$candle2),
    draw: ()=>(0, $f8dab26eb8b17592$export$c1384d250b581fb0)($4a3bf1a68fc18b3d$var$candle2)
};
const $4a3bf1a68fc18b3d$var$candle3 = {
    x: 12 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    y: 8 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    debug: false,
    room: "room-7-4",
    update: ()=>(0, $bbf478b8138cf072$export$2d8bb87b05f43b44)($4a3bf1a68fc18b3d$var$candle3),
    draw: ()=>(0, $f8dab26eb8b17592$export$c1384d250b581fb0)($4a3bf1a68fc18b3d$var$candle3)
};
const $4a3bf1a68fc18b3d$var$candle4 = {
    x: 10 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    y: 2 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    debug: false,
    room: "room-6-0",
    update: ()=>(0, $bbf478b8138cf072$export$2d8bb87b05f43b44)($4a3bf1a68fc18b3d$var$candle4),
    draw: ()=>(0, $f8dab26eb8b17592$export$c1384d250b581fb0)($4a3bf1a68fc18b3d$var$candle4)
};
const $4a3bf1a68fc18b3d$var$candle5 = {
    x: 8 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    y: 4 * (0, $82cbb14ddd640a4b$export$dea52d477af4398a),
    debug: false,
    room: "room-4-6",
    update: ()=>(0, $bbf478b8138cf072$export$2d8bb87b05f43b44)($4a3bf1a68fc18b3d$var$candle5),
    draw: ()=>(0, $f8dab26eb8b17592$export$c1384d250b581fb0)($4a3bf1a68fc18b3d$var$candle5)
};
const $4a3bf1a68fc18b3d$export$84278b8886d16bee = [
    $4a3bf1a68fc18b3d$var$candle1,
    $4a3bf1a68fc18b3d$var$candle2,
    $4a3bf1a68fc18b3d$var$candle3,
    $4a3bf1a68fc18b3d$var$candle4,
    $4a3bf1a68fc18b3d$var$candle5
];



window.addEventListener("keydown", (e)=>{
    switch(e.key){
        case "w":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.y = -(0, $fda0042d7ace4273$export$5f4276d44c62d457);
            break;
        case "a":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.x = -(0, $fda0042d7ace4273$export$5f4276d44c62d457);
            break;
        case "s":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.y = (0, $fda0042d7ace4273$export$5f4276d44c62d457);
            break;
        case "d":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.x = (0, $fda0042d7ace4273$export$5f4276d44c62d457);
            break;
    }
});
window.addEventListener("keyup", (e)=>{
    switch(e.key){
        case "w":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.y = 0;
            break;
        case "a":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.x = 0;
            break;
        case "s":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.y = 0;
            break;
        case "d":
            (0, $fda0042d7ace4273$export$615455393ee443ca).vel.x = 0;
            break;
        case "e":
            $ad9ff36f4afed11d$var$pickUpItem();
            break;
    }
});
window.addEventListener("mousedown", (e)=>{
    (0, $fda0042d7ace4273$export$615455393ee443ca).fire();
});
var $ef1e366503a5d8e0$exports = {};
$ef1e366503a5d8e0$exports = new URL("pickup.b7a52900.mp3", import.meta.url).toString();


const $ad9ff36f4afed11d$var$pickupURL = new URL($ef1e366503a5d8e0$exports);
const $ad9ff36f4afed11d$var$pickup = new Audio($ad9ff36f4afed11d$var$pickupURL.toString());
$ad9ff36f4afed11d$var$pickup.load();
const $ad9ff36f4afed11d$var$pickUpItem = ()=>{
    if ((0, $fda0042d7ace4273$export$615455393ee443ca).candle) {
        delete (0, $fda0042d7ace4273$export$615455393ee443ca).candle;
        $ad9ff36f4afed11d$var$pickup.play();
        return;
    }
    const roomCandles = (0, $4a3bf1a68fc18b3d$export$84278b8886d16bee).filter((candle)=>candle.room === (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.id);
    if (roomCandles.length < 1) return;
    for (const candle of roomCandles)if (Math.abs((0, $fda0042d7ace4273$export$615455393ee443ca).x - candle.x) <= (0, $82cbb14ddd640a4b$export$dea52d477af4398a) && Math.abs((0, $fda0042d7ace4273$export$615455393ee443ca).y - candle.y) <= (0, $82cbb14ddd640a4b$export$dea52d477af4398a)) {
        (0, $fda0042d7ace4273$export$615455393ee443ca).candle = candle;
        $ad9ff36f4afed11d$var$pickup.play();
        break;
    }
};






const $b1dc5b05612898eb$export$82127d6622dd9d9f = ()=>{
    (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.tiles.forEach((tile)=>{
        const isPlayerTile = tile.x === (0, $fda0042d7ace4273$export$615455393ee443ca).tile.x && tile.y === (0, $fda0042d7ace4273$export$615455393ee443ca).tile.y;
        tile.debug = isPlayerTile && (0, $fda0042d7ace4273$export$615455393ee443ca).debug;
    });
    (0, $c522274b58f2dbd7$export$723aa6ff9f95b23e).forEach((tile)=>{
        if (!tile.isAnimated) return;
        tile.acc++;
        if (tile.acc >= tile.frameDuration) {
            tile.acc = 0;
            tile.currentFrame++;
        }
        if (tile.currentFrame >= tile.graphicIndexes.length) tile.currentFrame = 0;
    });
};




const { ctx: $ad2bcec7a0192558$var$ctx } = (0, $b538644da75a1e4a$export$671da467341b3aba)();
const $ad2bcec7a0192558$var$update = (dt)=>{
    (0, $b1dc5b05612898eb$export$82127d6622dd9d9f)();
    (0, $fda0042d7ace4273$export$615455393ee443ca).update(dt);
    (0, $f2635be855952ad7$export$f1fd645118ed8be8).update(dt);
    (0, $4a3bf1a68fc18b3d$export$84278b8886d16bee).forEach((candle)=>candle.update());
    $ad2bcec7a0192558$var$spawnDemon();
};
const $ad2bcec7a0192558$var$render = (dt)=>{
    (0, $b538644da75a1e4a$export$a1c066623ac679d3)();
    (0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.draw();
    (0, $fda0042d7ace4273$export$615455393ee443ca).draw(dt);
    (0, $4a3bf1a68fc18b3d$export$84278b8886d16bee).forEach((candle)=>(0, $8ea1e13aabce4ae5$export$f9d3fff8c23da278).current.id === candle.room && candle.draw());
    (0, $f2635be855952ad7$export$f1fd645118ed8be8).draw();
// Debug altar bounds
// ctx.beginPath();
// ctx.rect(altarCoords.x, altarCoords.y, 8*3,8*3)
// ctx.stroke()
};
let $ad2bcec7a0192558$var$lastTimestamp = performance.now();
const $ad2bcec7a0192558$var$gameloop = ()=>{
    const timestamp = performance.now();
    const dt = (timestamp - $ad2bcec7a0192558$var$lastTimestamp) / 1000;
    $ad2bcec7a0192558$var$lastTimestamp = timestamp;
    $ad2bcec7a0192558$var$update(dt);
    $ad2bcec7a0192558$var$render(dt);
    window.requestAnimationFrame($ad2bcec7a0192558$var$gameloop);
};
window.requestAnimationFrame($ad2bcec7a0192558$var$gameloop);
const $ad2bcec7a0192558$var$altarCoords = {
    x: 48,
    y: 32
};

const $ad2bcec7a0192558$var$spawnSoundURL = new URL($4e7191e2caed83b6$exports);
const $ad2bcec7a0192558$var$spawnSound = new Audio($ad2bcec7a0192558$var$spawnSoundURL.toString());
$ad2bcec7a0192558$var$spawnSound.load();
const $ad2bcec7a0192558$var$spawnDemon = ()=>{
    if ((0, $f2635be855952ad7$export$f1fd645118ed8be8).isActive) return;
    if ((0, $fda0042d7ace4273$export$615455393ee443ca).candle) return;
    if ((0, $4a3bf1a68fc18b3d$export$84278b8886d16bee).some((candle)=>candle.room !== "room-3-3")) return;
    // Quick and dirty solution so check if all candles are incide the altar
    // TODO: Improve by getting altar coords from room data
    for (const candle of (0, $4a3bf1a68fc18b3d$export$84278b8886d16bee)){
        if (candle.x < $ad2bcec7a0192558$var$altarCoords.x) return;
        if (candle.x > $ad2bcec7a0192558$var$altarCoords.x + 24) return;
        if (candle.y < $ad2bcec7a0192558$var$altarCoords.y) return;
        if (candle.y > $ad2bcec7a0192558$var$altarCoords.y + 24) return;
    }
    (0, $f2635be855952ad7$export$f1fd645118ed8be8).isActive = true;
    $ad2bcec7a0192558$var$spawnSound.play();
};


//# sourceMappingURL=index.d7a25288.js.map
